__turbopack_context__.v({
  "childrenContainer": "IhG-bG_childrenContainer",
  "description": "IhG-bG_description",
  "descriptionContainer": "IhG-bG_descriptionContainer",
  "disabled": "IhG-bG_disabled",
  "expandButton": "IhG-bG_expandButton",
  "expandIcon": "IhG-bG_expandIcon",
  "expanded": "IhG-bG_expanded",
  "root": "IhG-bG_root",
});
